<template>
  <v-layout row pa-3>
    <v-fab-transition>
      <v-btn
        v-if="isAdmin"
        color="pink"
        dark
        fixed
        bottom
        right
        fab
        @click="createItem"
      >
        <v-icon>add</v-icon>
      </v-btn>
    </v-fab-transition>
    <v-flex xs12>
      <v-alert :value="noData" dismissible color="error" icon="warning" outlined
        >We can't find a plan. Please use plan id or plan code.</v-alert
      >
      <v-card>
        <v-toolbar text>
          <v-icon>style</v-icon>
          <v-toolbar-title>Plan ({{ items.length }} total)</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="searchQuery"
            v-on:keyup.enter="search(searchQuery)"
          ></v-text-field>
          <v-btn icon @click.stop="search(searchQuery)">
            <v-icon>search</v-icon>
          </v-btn>
        </v-toolbar>
        <v-data-table
          :headers="headers"
          :items="items"
          :must-sort="true"
          disable-pagination
          hide-default-footer
          class="mt-1"
        >
          <template v-slot:item="props">
            <tr>
              <td>
                <a v-if="isAdmin" @click.stop="updateItem(props.item)">{{
                  props.item.code
                }}</a>
                <span v-else>{{ props.item.code }}</span>
              </td>
              <td>{{ businessName(props.item) }}</td>
              <td>{{ props.item.created | moment("YYYY-DD-MM") }}</td>
              <td>
                <span
                  v-if="props.item.is_active"
                  class="green--text font-weight-medium"
                  >Active</span
                >
                <span v-else class="red--text font-weight-medium"
                  >Inactive</span
                >
              </td>
              <td>
                <v-btn icon @click.stop="updateItem(props.item)" v-if="isAdmin">
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn
                  icon
                  @click.stop="removeItem(props.item.id)"
                  v-if="isAdmin"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
          <template v-slot:no-data>No data</template>
        </v-data-table>
        <v-footer class="pt-5"></v-footer>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import fb from "@/firebase";
import { mapState, mapMutations, mapGetters } from "vuex";

import PlanForm from "@/components/PlanForm";

const plans = fb.db.collection("business_plans");

export default {
  components: {},
  data: () => ({
    newItemName: "",
    currentItem: {},
    searchQuery: "",
    noData: false,
    items: [],
    headers: [
      { text: "Code", value: "code" },
      { text: "Business", value: "business", sortable: false },
      { text: "Created", value: "created" },
      { text: "Status", value: "status", sortable: false },
      { text: "Actions", value: "name", sortable: false, align: "center" }
    ],
    total: 0
  }),
  computed: {
    ...mapState({
      businesses: "businesses",
      planList: "plans"
    }),
    ...mapGetters(["isAdmin"])
  },
  firestore: {
    items: plans
  },
  mounted: function() {},
  methods: {
    ...mapMutations(["setAppAlert"]),
    createItem() {
      const voidPlan = {
        name: {
          en: "",
          fr: ""
        },
        title: {
          en: "",
          fr: ""
        },
        content: {
          en: "",
          fr: ""
        },
        perks: {
          en: [],
          fr: []
        }
      };
      this.$modal.show(
        PlanForm,
        {
          plan: voidPlan
        },
        {
          height: "auto",
          scrollable: true
        }
      );
    },
    removeItem: function(id) {
      if (id) {
        if (confirm("Are you sure ?")) {
          plans.doc(id).delete();
          let planIndex = this.planList.findIndex(function(element) {
            return element.id === id;
          });
          this.planList.splice(planIndex, 1);
          this.setAppAlert({
            visible: true,
            text: "The plan has been removed",
            color: "success"
          });
        }
      }
    },
    updateItem(item) {
      this.currentItem = Object.assign({}, item);
      this.currentItem.id = item.id;
      this.$modal.show(
        PlanForm,
        {
          plan: this.currentItem
        },
        {
          height: "auto",
          scrollable: true
        }
      );
    },
    businessName: function(item) {
      if (item.business) {
        let business = this.businesses.find(function(element) {
          return element.id === item.business;
        });
        if (business !== undefined) {
          return business.name;
        }
        return "";
      }
    },
    search: function(query) {
      this.noData = false;
      if (query && query.length >= 5) {
        plans
          .where("code", "==", query)
          .get()
          .then(snapshot => {
            if (!snapshot.empty) {
              snapshot.forEach(doc => {
                this.items = [doc.data()];
              });
            } else {
              plans
                .doc(query)
                .get()
                .then(doc => {
                  if (doc.data()) {
                    this.items = [doc.data()];
                  } else {
                    this.noData = true;
                  }
                })
                .catch(() => {
                  this.noData = true;
                });
            }
          });
      } else {
        this.items = [];
        plans
          .orderBy("name", "asc")
          .get()
          .then(snapshot => {
            snapshot.forEach(doc => {
              const plan = Object.assign({}, { id: doc.id }, doc.data());
              let business = this.businesses.find(business => {
                return business.id === plan.business;
              });
              plan.business_name = business.name;
              this.items.push(plan);
            });
          })
          .catch();
      }
    }
  }
};
</script>
